
import { Component, Input, inject } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'cerrix-checkbox',
    imports: [
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule
],
    templateUrl: './cerrix-checkbox.component.html',
    styleUrl: './cerrix-checkbox.component.scss'
})
export class CerrixCheckboxComponent implements ControlValueAccessor {
  protected ngControl = inject(NgControl, { optional: true, self: true });

  @Input() public label!: string;
  @Input() public disabled?: boolean = false;
  @Input() public value: boolean = false;
  @Input() public dataUiid: string = "undefined"

  constructor() {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }
  // protected onChange(event: Event) {
  //   this.value = (event.target as HTMLInputElement)?.value;
  //   this.onValueChange(this.value);
  // }

  private onValueChange = (value: boolean) => {};
  private onTouched = () => {};

  public writeValue(value: boolean): void {
    this.value = value;
  }
  public registerOnChange(onChange: (value: boolean) => void): void {
    this.onValueChange = onChange;
  }
  public registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }
  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
